import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { RouterProvider } from "./app/router";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/components.css";
import "./styles/designer.css";
import "./portfolio-system.css"; // LDKTECH_PORTFOLIO_SYSTEM

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider>
      <App />
    </RouterProvider>
  </StrictMode>,
);
